// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"157":"975f6174","978":"a1d97da0"}[chunkId] + ".css";
};